export enum AccordionInfo {
  VIEWS_AND_FILTERS = 'View And Filters',
  BREAKDOWN = 'Breakdown'
}

export enum EchartOption {
  STACK = 'Stack Chart',
  GRID = 'Data View',
  BARCHART = 'Bar Chart',
  LINECHART = 'Line Chart',
  COUNT = 'Count',
  PERCENTAGES = 'Percentages',
  MONTH = 'Month',
  QUARTER = 'Quarter',
  DAY_DATE = 'DayDate',
  MONTH_DATE = 'MonthDate',
  YEAR_DATE = 'YearDate',
  RATIO = 'Ratio',
  RATIO_SUM = 'Ratio Sum',
  CUSTOM_CHART = 'Custom Chart',
  PIE_CHART = 'Pie Chart'
}

export const DEFAULT_CHART_COLORS = [
  '#5470c6',
  '#91cc75',
  '#fac858',
  '#ee6666',
  '#73c0de',
  '#3ba272',
  '#fc8452',
  '#9a60b4',
  '#ea7ccc'
];
